import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { caps12, p14 } from '../../styles/typography';

export const LeaderboardTable = styled.table`
  width: 100%;
  tr {
  }
  thead tr th {
    ${caps12};
    padding: 0 ${gutter(1)};
    height: 64px;

    text-transform: uppercase;
    text-align: left;
    font-weight: 500;

    color: ${color('gray80')};
  }
  tbody tr td {
    ${p14};
    font-weight: 500;
    padding: 0 ${gutter(1)};
    color: ${color('gray90')};
    height: 64px;
    text-transform: uppercase;
  }
  tbody tr {
    transition: background-color 1s ease-in-out;
    background-color: white;
  }
  tbody tr:nth-child(even) {
    background-color: ${color('gray10')};
  }
  tbody tr td[placeholder] {
    opacity: 0.5;
  }
  tbody tr[data-highlight='true'] {
    background-color: ${color('orange20')};
  }
`;
